// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/_extract-text-webpack-plugin@3.0.2@extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true,"publicPath":"../../"}!./node_modules/_vue-style-loader@3.1.2@vue-style-loader!./node_modules/_css-loader@0.28.11@css-loader?{"sourceMap":true}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-61bf3f38","scoped":false,"hasInlineConfig":false}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=1!./src/components/public/ai-streaming-text.vue
// module id = YwEg
// module chunks = 42